import { Injectable } from '@angular/core';
import { Profile } from '@cyborg-monorepo/hunter/common';
import { environment } from '../../../../environments/environment';
import { UserService } from './user.service';
import {
  TrackingEventEnum,
  TrackingService,
} from '../../../tracking/tracking.service';

declare global {
  interface Window {
    Calendly: {
      initPopupWidget(params: {
        url: string;
        prefill: {
          name: string;
          email: string;
          customAnswers: {
            a1: string;
          };
        };
      }): void;
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class CalendlyService {
  private profile: Profile;
  constructor(
    private userService: UserService,
    private trackingService: TrackingService,
  ) {
    this.userService.getProfile().subscribe((profile) => {
      this.profile = profile;
    });
  }

  public talkToCyborg(): void {
    this.trackingService.trackEvent(
      TrackingEventEnum.COMMUNITY_CALENDLY_DIALOG_OPENED,
    );
    window.Calendly.initPopupWidget({
      url: environment.calendlyUrl,
      prefill: {
        name: this.profile.firstName + ' ' + this.profile.lastName,
        email: this.profile.email,
        customAnswers: {
          a1: this.profile.company.name,
        },
      },
    });
  }
}
